/* Mile High Airguns — cart drawer, AJAX add-to-cart, predictive search */
(function () {
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var overlay  = document.getElementById('CartOverlay');
  var itemsEl  = document.getElementById('CartItems');
  var subtotal = document.getElementById('CartSubtotal');
  var footEl   = document.getElementById('CartFoot');
  var emptyEl  = document.getElementById('CartEmpty');
  var progEl   = document.getElementById('CartProgress');
  var countEls = document.querySelectorAll('[data-cart-count]');

  var drawer = document.getElementById('CartDrawer'), drawerFocus = null;
  var cartError = document.getElementById('CartError'), cartChanging = false;
  function clearCartError() { if (cartError) { cartError.hidden = true; cartError.textContent = ''; } }
  function showCartError(error, fallback) { if (cartError) { cartError.textContent = (error && error.cartMessage) || fallback; cartError.hidden = false; } }
  function cartResponse(response, fallback) { return response.json().then(function (data) { if (!response.ok || !Array.isArray(data.items)) { var error = new Error(fallback); error.cartMessage = typeof data.description === 'string' ? data.description : fallback; throw error; } return data; }); }
  if (drawer) { drawer.inert = !document.body.classList.contains('cart-open'); drawer.setAttribute('role','dialog'); drawer.setAttribute('aria-modal','true'); }
  function openDrawer() { drawerFocus = document.activeElement; if(drawer)drawer.inert=false; document.body.classList.add('cart-open'); var close=drawer&&drawer.querySelector('[data-cart-close]'); if(close)close.focus(); }
  function closeDrawer() { if(!document.body.classList.contains('cart-open'))return; document.body.classList.remove('cart-open'); if(drawer)drawer.inert=true; if(drawerFocus&&drawerFocus.isConnected)drawerFocus.focus(); }
  document.addEventListener('keydown',function(e){if(e.key!=='Tab'||!drawer||!document.body.classList.contains('cart-open'))return;var focus=Array.from(drawer.querySelectorAll('button,a[href],input,select,textarea')).filter(function(el){return !el.disabled&&el.getClientRects().length;});if(!focus.length)return;var first=focus[0],last=focus[focus.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}});


  function renderProgress(cart) {
    if (!progEl) return;
    var thr = parseInt(progEl.getAttribute('data-threshold'), 10) || 0;
    if (thr <= 0 || cart.item_count === 0) { progEl.hidden = true; return; }
    var msg = progEl.querySelector('.cart-progress__msg');
    var fill = progEl.querySelector('.cart-progress__fill');
    var pct = Math.max(0, Math.min(100, (cart.total_price / thr) * 100));
    fill.style.width = pct + '%';
    var remain = thr - cart.total_price;
    if (remain > 0) {
      progEl.classList.remove('is-complete');
      msg.innerHTML = 'You\u2019re <strong>' + money(remain) + '</strong> away from free ground shipping on eligible orders';
    } else {
      progEl.classList.add('is-complete');
      msg.innerHTML = '\u2713 Free ground shipping threshold met · Eligibility confirmed at checkout';
    }
    progEl.hidden = false;
  }


  var suggestionsEl = document.getElementById('CartSuggestions');
  var suggestionRevision = 0;
  function renderSuggestions(cart) {
    if (!suggestionsEl) return;
    var revision = ++suggestionRevision;
    suggestionsEl.hidden = true;
    suggestionsEl.replaceChildren();
    if (!cart.item_count) return;
    var rifles = cart.items.filter(function (item) { return item.product_type === 'Air Rifles'; }).slice(0, 3);
    if (!rifles.length) return;
    var inCart = cart.items.map(function (item) { return String(item.product_id); });
    Promise.all(rifles.map(function (item) {
      var url = new URL(item.url, window.location.origin);
      if (url.origin !== window.location.origin) return Promise.resolve([]);
      url.searchParams.set('variant', item.variant_id || item.id);
      return fetch(url.toString(), { headers: { 'Accept': 'text/html' } })
        .then(function (response) { if (!response.ok) throw new Error('Unavailable'); return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var setup = doc.querySelector('[data-setup-grid]');
          return setup ? Array.from(setup.querySelectorAll('.setup-card:not([hidden])')) : [];
        }).catch(function () { return []; });
    })).then(function (groups) {
      if (revision !== suggestionRevision) return;
      var seen = inCart.slice();
      var cards = [];
      groups.forEach(function (group) { group.forEach(function (card) {
        var id = card.getAttribute('data-accessory-id');
        if (cards.length >= 3 || (id && seen.indexOf(id) !== -1)) return;
        if (id) seen.push(id);
        cards.push(document.importNode(card, true));
      }); });
      if (!cards.length) return;
      var title = document.createElement('h2');
      title.className = 'disp'; title.textContent = 'Complete your PCP setup';
      suggestionsEl.appendChild(title);
      cards.forEach(function (card) { suggestionsEl.appendChild(card); });
      suggestionsEl.hidden = false;
    }).catch(function () { suggestionsEl.hidden = true; });
  }

  function render(cart) {
    renderSuggestions(cart);
    countEls.forEach(function (e) { e.textContent = cart.item_count; e.hidden = cart.item_count === 0; });
    renderProgress(cart);
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (it) {
      var media = it.image
        ? '<img class="cd-item__img" src="' + it.image + '" alt="">'
        : '<div class="cd-item__ph"></div>';
      return '<div class="cd-item" data-key="' + esc(it.key) + '">' + media +
        '<div class="cd-item__mid">' +
          '<div class="cd-item__vendor">' + esc(it.vendor || '') + '</div>' +
          '<div class="cd-item__title">' + esc(it.product_title) + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cd-item__variant">' + esc(it.variant_title) + '</div>' : '') +
          '<div class="cd-item__row">' +
            '<div class="cd-qty">' +
              '<button type="button" data-dec aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-inc aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="cd-item__price">' + money(it.final_line_price) + '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cd-item__rm" data-remove aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('');
    if (subtotal) subtotal.textContent = money(cart.total_price);
  }

  function getCart() {
    var fallback = drawer.getAttribute('data-cart-load-error');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return cartResponse(r, fallback); }).then(function (cart) { clearCartError(); render(cart); });
  }
  function change(key, qty) {
    if (cartChanging) return Promise.resolve();
    cartChanging = true;
    clearCartError();
    var fallback = drawer.getAttribute('data-cart-update-error');
    drawer.querySelectorAll('[data-inc],[data-dec],[data-remove]').forEach(function (button) { button.disabled = true; });
    if (itemsEl) itemsEl.setAttribute('aria-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return cartResponse(r, fallback); }).then(render)
      .catch(function (error) { showCartError(error, fallback); })
      .finally(function () { cartChanging = false; if (itemsEl) itemsEl.removeAttribute('aria-busy'); drawer.querySelectorAll('[data-inc],[data-dec],[data-remove]').forEach(function (button) { button.disabled = false; }); });
  }
  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'Unable to add this option. Please try again.'); return data; }); })
      .then(function () { return getCart().then(openDrawer).catch(function () { window.location.assign('/cart'); }); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.js-add');
    if (!form) return;
    e.preventDefault();
    var idEl = form.querySelector('[name=id]');
    if (!idEl) { form.submit(); return; }
    var qtyEl = form.querySelector('[name=quantity]');
    var btn = form.querySelector('[type=submit]');
    if (form.getAttribute('data-submitting') === 'true' || (btn && btn.disabled)) return;
    form.setAttribute('data-submitting', 'true');
    var errorEl = form.querySelector('[data-cart-error]');
    if (!errorEl) { errorEl = document.createElement('p'); errorEl.setAttribute('data-cart-error', ''); errorEl.setAttribute('role', 'alert'); form.appendChild(errorEl); }
    errorEl.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    addVariant(idEl.value, qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1)
      .catch(function (error) { errorEl.textContent = error.message || 'Unable to add this option. Please try again.'; errorEl.hidden = false; })
      .finally(function () { form.removeAttribute('data-submitting'); if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } form.dispatchEvent(new CustomEvent('mha:cart-settled', { bubbles: true })); });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); getCart().then(openDrawer).catch(function (error) { openDrawer(); showCartError(error, drawer.getAttribute('data-cart-load-error')); }); return; }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeDrawer(); return; }
    if (e.target.closest('[data-sticky-add]')) {
      var f = document.querySelector('.product-form');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      return;
    }
    var row = e.target.closest('.cd-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var span = row.querySelector('.cd-qty span');
    var q = parseInt(span ? span.textContent : '1', 10);
    if (e.target.closest('[data-inc]')) change(key, q + 1);
    else if (e.target.closest('[data-dec]')) change(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-remove]')) change(key, 0);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (document.querySelector('[data-cart-count]')) getCart().catch(function (error) { showCartError(error, drawer.getAttribute('data-cart-load-error')); });

  /* ---------------- Predictive search ---------------- */
  var searchWrap = document.querySelector('[data-search]');
  if (searchWrap) {
    var input = searchWrap.querySelector('[data-search-input]');
    var panel = searchWrap.querySelector('[data-predictive]');
    var timer;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { panel.hidden = true; panel.innerHTML = ''; return; }
      timer = setTimeout(function () { run(q); }, 220);
    });

    function run(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6' +
        '&resources[options][unavailable_products]=' + (searchWrap.getAttribute('data-unavailable') || 'last');
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { draw(q, data); })
        .catch(function () { panel.hidden = true; });
    }

    var searchCurrency = searchWrap.getAttribute('data-currency') || 'USD';
    function searchMoney(value) {
      if (value === null || value === undefined || value === '') return '';
      var amount = Number(value);
      if (!Number.isFinite(amount)) return '';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: searchCurrency }).format(amount); }
      catch (error) { return '$' + amount.toFixed(2); }
    }
    // Resolve superseded listings to their live combined product, including cached search results.
    var mergedSearchProducts = [];
    var mergedSearchData = searchWrap.querySelector('[data-search-merged-products]');
    if (mergedSearchData) {
      try { mergedSearchProducts = JSON.parse(mergedSearchData.textContent); } catch (error) { mergedSearchProducts = []; }
    }
    function canonicalSearchProducts(products) {
      var seen = new Set();
      return products.map(function (product) {
        var path;
        try { path = new URL(product.url, window.location.origin).pathname; } catch (error) { return product; }
        return mergedSearchProducts.find(function (merged) { return merged.url === path || merged.aliases.indexOf(path) !== -1; }) || product;
      }).filter(function (product) {
        var path;
        try { path = new URL(product.url, window.location.origin).pathname; } catch (error) { return true; }
        if (seen.has(path)) return false;
        seen.add(path); return true;
      });
    }
    function draw(q, data) {
      var res = (data.resources && data.resources.results) || {};
      var products = canonicalSearchProducts(res.products || []);
      var colls = res.collections || [];
      if (!products.length && !colls.length) {
        panel.innerHTML = '<div class="predictive__empty">No matches for \u201c' + esc(q) + '\u201d</div>';
        panel.hidden = false; return;
      }
      var html = '';
      if (colls.length) {
        html += '<div class="predictive__label mono">Categories</div>';
        html += colls.map(function (c) {
          return '<a class="predictive__coll" href="' + c.url + '">' + esc(c.title) + '</a>';
        }).join('');
      }
      if (products.length) {
        html += '<div class="predictive__label mono">Products</div>';
        html += products.map(function (p) {
          var src = p.image || (p.featured_image && p.featured_image.url) || '';
          var img = src ? '<img src="' + src + '" alt="">' : '<span class="predictive__ph"></span>';
          var formattedPrice = searchMoney(p.price);
          var price = formattedPrice ? '<span class="predictive__price">' + (p.price_varies ? 'From ' : '') + esc(formattedPrice) + '</span>' : '';
          return '<a class="predictive__item" href="' + p.url + '">' + img +
            '<span class="predictive__meta"><span class="predictive__title">' + esc(p.title) + '</span>' +
            '<span class="predictive__vendor">' + esc(p.vendor || '') + '</span></span>' + price + '</a>';
        }).join('');
      }
      html += '<a class="predictive__all" href="/search?q=' + encodeURIComponent(q) + (searchWrap.getAttribute('data-unavailable') === 'hide' ? '&options%5Bunavailable_products%5D=hide' : '') + '">See all results \u2192</a>';
      panel.innerHTML = html;
      panel.hidden = false;
    }

    document.addEventListener('click', function (e) { if (!searchWrap.contains(e.target)) panel.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.hidden = true; });
  }
})();

/* Category carousel: shows a few tiles, auto-rotates through the full list */
(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-carousel-track]');
    if (!track || track.children.length === 0) return;
    var tiles = track.children;
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    var index = 0, timer = null;

    function metrics() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var tileW = tiles[0].getBoundingClientRect().width + gap;
      var vp = track.parentElement.getBoundingClientRect().width;
      var perView = Math.max(1, Math.round(vp / tileW));
      return { tileW: tileW, maxIndex: Math.max(0, tiles.length - perView) };
    }
    function go(i) {
      var m = metrics();
      if (m.maxIndex === 0) {
        track.style.transform = 'translateX(0)';
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      if (prev) prev.hidden = false;
      if (next) next.hidden = false;
      if (i > m.maxIndex) i = 0;
      if (i < 0) i = m.maxIndex;
      index = i;
      track.style.transform = 'translateX(' + (-index * m.tileW) + 'px)';
    }
    function start() { stop(); timer = setInterval(function () { go(index + 1); }, 3500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    car.addEventListener('focusin', stop);
    car.addEventListener('focusout', start);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { go(index); }, 150); });

    go(0);
    start();
  });
})();

/* Infinite scroll on collection pages (auto-load next page, Load more fallback) */
(function () {
  var foot = document.querySelector('[data-infinite-scroll]');
  var grid = document.querySelector('[data-infinite-grid]');
  var sortParams=new window.URL(window.location.href).searchParams;
  var optionSort=sortParams.has('filter.p.m.custom.airgun_caliber') && /^price-/.test(sortParams.get('sort_by')||'');
  function sortOptions(){if(!grid||!optionSort)return;var cards=Array.from(grid.children),direction=sortParams.get('sort_by')==='price-descending'?-1:1;cards.sort(function(a,b){return direction*(Number(a.getAttribute('data-option-price'))-Number(b.getAttribute('data-option-price')));});cards.forEach(function(card){grid.appendChild(card);});}
  var countEl = document.querySelector('[data-product-count]');
  function updateProductCount() { if (!countEl || !grid) return; var label = countEl.getAttribute('data-complete-count-label'); if (label) countEl.textContent = label.replace('__COUNT__', grid.querySelectorAll('.pcard').length); }
  if(!foot){sortOptions();updateProductCount();return;}
  var sentinel = foot.querySelector('[data-infinite-sentinel]');
  var spinner = foot.querySelector('[data-infinite-spinner]');
  var link = foot.querySelector('[data-infinite-next]');
  if (!grid || !link) { sortOptions(); return; }

  var nextUrl = link.getAttribute('href');
  var loading = false;
  var observer = null;
  var sortNotice=null;
  if(optionSort){sortNotice=document.createElement('p');sortNotice.setAttribute('role','status');sortNotice.textContent='Loading all matching options to sort by the listed caliber price…';foot.prepend(sortNotice);grid.hidden=true;grid.setAttribute('aria-busy','true');}

  function finish() {
    sortOptions();grid.hidden=false;grid.removeAttribute('aria-busy');
    updateProductCount();
    if (sortNotice) sortNotice.textContent='Prices sorted for the listed caliber option.';
    if (link) link.remove();
    if (sentinel) sentinel.remove();
    if (spinner) spinner.hidden = true;
    if (observer) observer.disconnect();
  }

  function load() {
    if (loading || !nextUrl) return;
    loading = true;
    if (spinner) spinner.hidden = false;
    if (link) link.style.display = 'none';

    fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if(!r.ok)throw new Error('Unavailable');return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.querySelector('[data-infinite-grid]');
        if (!ng)throw new Error('Unavailable');
        if (ng) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(ng.children).forEach(function (n) { frag.appendChild(n); });
          grid.appendChild(frag);
        }
        var nl = doc.querySelector('[data-infinite-next]');
        nextUrl = nl ? nl.getAttribute('href') : null;
        loading = false;
        if (spinner) spinner.hidden = true;
        if (!nextUrl) {
          finish();
        } else if (link) {
          link.style.display = '';
          link.setAttribute('href', nextUrl);
        }
        /* a page of hidden (sold-out) products adds no height, so the observer never re-fires */
        if (nextUrl && (optionSort || (sentinel && sentinel.getBoundingClientRect().top < window.innerHeight + 700))) load();
      })
      .catch(function () {
        loading = false;
        if (spinner) spinner.hidden = true;
        if (link) link.style.display = '';
        if(optionSort){grid.hidden=false;grid.removeAttribute('aria-busy');sortOptions();sortNotice.textContent='Only loaded options are shown. Use Load more to complete the price-sorted list.';}
      });
  }

  link.addEventListener('click', function (e) { e.preventDefault(); load(); });

  if(optionSort){load();return;}
  if ('IntersectionObserver' in window && sentinel) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) load(); });
    }, { rootMargin: '700px 0px' });
    observer.observe(sentinel);
  }
})();

/* Product image gallery + zoom lightbox */
(function () {
  var gallery = document.querySelector('[data-gallery]');
  var lightbox = document.querySelector('[data-lightbox]');
  if (!gallery || !lightbox) return;

  var mainImg = gallery.querySelector('[data-main-img]');
  var thumbs = gallery.querySelectorAll('[data-thumb]');
  var dataEl = gallery.querySelector('[data-gallery-data]');
  var images = [];
  try { images = JSON.parse(dataEl.textContent) || []; } catch (e) { images = []; }
  if (images.length === 0) return;

  var lbImg = lightbox.querySelector('[data-lightbox-img]');
  var lbStage = lightbox.querySelector('[data-lightbox-stage]');
  var lbCount = lightbox.querySelector('[data-lightbox-count]');
  var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-lightbox-next]');
  var current = 0;
  var zoomed = false;
  var galleryFocus = null;

  // In-page thumbnail switching
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = parseInt(t.getAttribute('data-index'), 10) || 0;
      current = i;
      if (mainImg) mainImg.src = t.getAttribute('data-full');
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  function resetZoom() {
    zoomed = false;
    lbImg.classList.remove('is-zoomed');
    lbImg.style.transform = '';
    lbImg.style.transformOrigin = 'center center';
  }
  function show(i) {
    current = (i + images.length) % images.length;
    resetZoom();
    lbImg.src = images[current];
    if (lbCount) lbCount.textContent = (current + 1) + ' / ' + images.length;
    var multi = images.length > 1;
    if (prevBtn) prevBtn.hidden = !multi;
    if (nextBtn) nextBtn.hidden = !multi;
  }
  function open(i) {
    galleryFocus = document.activeElement;
    show(i);
    lightbox.hidden = false;
    document.body.classList.add('lightbox-open');
    lightbox.querySelector('[data-lightbox-close]').focus();
  }
  function close() {
    if(lightbox.hidden)return;
    lightbox.hidden = true;
    document.body.classList.remove('lightbox-open');
    resetZoom();
    if(galleryFocus&&galleryFocus.isConnected)galleryFocus.focus();
  }

  var openBtn = gallery.querySelector('[data-gallery-open]');
  if (openBtn) openBtn.addEventListener('click', function () { open(current); });

  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);

  // Click backdrop (not image) closes
  lbStage.addEventListener('click', function (e) { if (e.target === lbStage) close(); });

  // Click image toggles 2x zoom; pan follows cursor
  lbImg.addEventListener('click', function (e) {
    e.stopPropagation();
    zoomed = !zoomed;
    lbImg.classList.toggle('is-zoomed', zoomed);
    lbImg.style.transform = zoomed ? 'scale(2.3)' : '';
  });
  lbStage.addEventListener('mousemove', function (e) {
    if (!zoomed) return;
    var r = lbImg.getBoundingClientRect();
    var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    lbImg.style.transformOrigin = x + '% ' + y + '%';
  });

  document.addEventListener('keydown', function (e) {
    if (lightbox.hidden) return;
    if(e.key==='Tab'){var focus=Array.from(lightbox.querySelectorAll('button')).filter(function(b){return !b.hidden&&!b.disabled;});var first=focus[0],last=focus[focus.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();

/* Keep pellet suggestions in step with the selected rifle caliber. */
(function () {
  var setup = document.querySelector('[data-setup]');
  if (!setup) return;
  var select = document.querySelector('[data-variant-select]');
  var title = document.querySelector('.product__title');
  function sync() {
    var option = select ? select.options[select.selectedIndex].getAttribute('data-option-title') : 'Default Title';
    var source = document.querySelector('[data-buying-specs]'), data = null;
    try { data = source ? JSON.parse(source.textContent) : null; } catch (e) {}
    var selected = data && data.byOption && data.byOption[option];
    var verified = selected && selected.caliber;
    if (!verified && data && data.calibers && data.calibers.length === 1) verified = data.calibers[0];
    var specs = verified || ((select ? select.options[select.selectedIndex].textContent : '') + ' ' + (title ? title.textContent : ''));
    var match = specs.match(/\.(177|22|25|30)(?!\d)/);
    var token = match ? '.' + match[1] : '';
    var found = false;
    setup.querySelectorAll('[data-caliber]').forEach(function (card) {
      card.hidden = card.getAttribute('data-caliber') !== token;
      if (!card.hidden) found = true;
    });
    var fallback = setup.querySelector('[data-ammo-fallback]');
    if (fallback) fallback.hidden = found;
  }
  if (select) select.addEventListener('change', sync);
  sync();
})();

/* Sort caliber values numerically and keep filter popovers exclusive. */
(function () {
  var facets = Array.from(document.querySelectorAll('details.facet'));
  document.querySelectorAll('details.facet').forEach(function (facet) {
    var title=facet.querySelector('summary').textContent.trim(), list=facet.querySelector('.facet__opts');
    if(!list||!/caliber|pellet weight|pellet diameter/i.test(title))return;
    var values=Array.from(list.querySelectorAll('.facet__opt'));
    function size(label){var text=label.textContent.trim(),match=text.match(/(?:\d*\.)?\d+/);if(!match)return Infinity;var number=Number(match[0]);return /mm/i.test(text)&&/caliber/i.test(title)?number/25.4:number;}
    values.sort(function(a,b){return size(a)-size(b)||a.textContent.localeCompare(b.textContent);});
    values.forEach(function(label){list.appendChild(label);});
    if(/ammo caliber/i.test(title)){
      var common=['.177','.20','.22','.25','.30','.35','.357','.45','.50','.51','.62','.68'];
      var primary=values.filter(function(label){return common.indexOf(label.querySelector('input').value)!==-1;});
      var precise=values.filter(function(label){return primary.indexOf(label)===-1;});
      if(primary.length&&precise.length){
        list.replaceChildren();
        function heading(text){var h=document.createElement('p');h.className='facet__group-title';h.textContent=text;h.style.cssText='font-weight:700;margin:12px 0 6px';list.appendChild(h);}
        heading('Common caliber choices');primary.forEach(function(label){list.appendChild(label);});
        heading('Other listed sizes');precise.forEach(function(label){list.appendChild(label);});
        var note=document.createElement('p');note.textContent='Use the exact size specified by your airgun manufacturer. Nearby diameters are not automatically interchangeable.';note.style.cssText='font-size:12px;line-height:1.5;margin:12px 0';list.appendChild(note);
      }
    }
  });
  function closeFacets(except) {
    facets.forEach(function (facet) { if (facet !== except) facet.open = false; });
  }
  facets.forEach(function (facet) {
    facet.addEventListener('toggle', function () { if (facet.open) closeFacets(facet); });
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('details.facet')) closeFacets();
  });
  document.addEventListener('focusin', function (event) {
    if (!event.target.closest('details.facet')) closeFacets();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var active = facets.find(function (facet) { return facet.open; });
    if (!active) return;
    closeFacets();
    active.querySelector('summary').focus();
  });
})();

/* Selected option specifications and explicit sticky option. */
(function(){
  var select=document.querySelector('[data-variant-select]'), source=document.querySelector('[data-buying-specs]'), box=document.querySelector('[data-selected-specs]'), data;
  try{data=source?JSON.parse(source.textContent):null;}catch(e){data=null;}
  function list(el,values){if(!el)return;el.replaceChildren();(values||[]).forEach(function(text){var li=document.createElement('li');li.textContent=text;el.appendChild(li);});}
  function sync(){
    var option=select?select.options[select.selectedIndex].getAttribute('data-option-title'):'Default Title';
    var sticky=document.querySelector('[data-sticky-option]');if(sticky)sticky.textContent=option==='Default Title'?'':option;
    if(!data||!box)return;var spec=data.byOption&&data.byOption[option];if(!spec||!spec.facts||!spec.facts.length){box.hidden=true;return;}
    box.hidden=false;box.querySelector('[data-spec-option]').textContent=option==='Default Title'?(spec.caliber||''):option;
    var all=spec.facts||[], priority=all.filter(function(f){return /caliber|pneumatic|precharged|pre-charged|action|regulated|capacity|bb mag|single-shot|dovetail|pump range|fill pressure|weight:|magnification|tube|focal|parallax/i.test(f);});
    list(box.querySelector('[data-spec-summary]'),(priority.length?priority:all).slice(0,6));list(box.querySelector('[data-spec-full]'),all);
    var included=box.querySelector('[data-spec-included]');included.hidden=!(spec.included&&spec.included.length);list(included.querySelector('ul'),spec.included);
    var links=box.querySelector('[data-spec-source]');links.replaceChildren();links.hidden=!(data.source||data.manual);
    [['Manufacturer information',data.source],['Manuals',data.manual]].forEach(function(pair){if(!pair[1])return;try{var url=new window.URL(pair[1]);if(url.protocol!=='https:')return;var a=document.createElement('a');a.href=url.href;a.textContent=pair[0];a.target='_blank';a.rel='noopener';links.appendChild(a);links.appendChild(document.createTextNode(' · '));}catch(e){}});
    /* Keep the original selling description and caution paragraphs; the selected facts replace its imported, mixed-caliber list. */
    var desc=document.querySelector('[data-original-description]');if(desc){desc.querySelectorAll('ul').forEach(function(ul){var cautions=Array.from(ul.querySelectorAll('li')).filter(function(li){return /please note|warning|caution|not included|not compatible|do not|safety/i.test(li.textContent);});if(cautions.length){Array.from(ul.querySelectorAll('li')).forEach(function(li){li.hidden=cautions.indexOf(li)===-1;});}else{ul.hidden=true;var heading=ul.previousElementSibling;if(heading&&/^H[234]$/.test(heading.tagName)&&/cal|specification/i.test(heading.textContent))heading.hidden=true;}});desc.querySelectorAll('h3').forEach(function(h){if(/specifications by caliber/i.test(h.textContent))h.hidden=true;});}
  }
  if(select)select.addEventListener('change',sync);sync();
  document.addEventListener('click',function(e){if(e.target.closest('[data-change-option]')&&select){select.scrollIntoView({block:'center',behavior:'smooth'});select.focus();}});
  /* Preserve incoming links that used the superseded option-only caliber filter. */
  if(document.querySelector('.collection')){var u=new window.URL(window.location.href), old=u.searchParams.getAll('filter.v.option.caliber');if(old.length){u.searchParams.delete('filter.v.option.caliber');old.forEach(function(v){u.searchParams.append('filter.p.m.custom.airgun_caliber',v.split(' ')[0]);});window.location.replace(u.toString());}}
})();

/* Compare up to three products without changing the cart. */
(function(){
  if(!document.querySelector('[data-compare-product]'))return;
  var selected=[],lastFocus=null;
  var tray=document.createElement('div');tray.className='compare-tray';tray.hidden=true;tray.innerHTML='<span data-compare-count aria-live="polite"></span><button type="button" class="btn btn--brass btn--sm" data-show-comparison>Compare selected</button><button type="button" class="btn btn--ghost btn--sm" data-clear-comparison>Clear</button>';
  var modal=document.createElement('div');modal.className='mha-compare';modal.hidden=true;modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-labelledby','CompareHeading');modal.innerHTML='<div class="mha-compare__panel"><div class="mha-compare__header"><h2 id="CompareHeading" class="disp">Compare products</h2><button type="button" class="btn btn--ghost btn--sm" data-close-comparison>Close</button></div><div class="mha-compare__scroll" data-comparison-table></div><p class="mha-compare__note">Prices and stock refer to the option shown. Check the product page for other options. “Not listed” means the catalog has no confirmed value. Required equipment is general buying guidance; verify fittings, pressure ratings and compatibility before purchase.</p><p class="mha-compare__status" role="status" data-comparison-status></p></div>';
  document.body.appendChild(tray);document.body.appendChild(modal);
  function update(){tray.hidden=!selected.length;tray.querySelector('[data-compare-count]').textContent=selected.length+' of 3 selected';document.querySelectorAll('[data-compare-product]').forEach(function(b){try{var p=JSON.parse(b.getAttribute('data-compare-product'));var active=selected.some(function(s){return s.id===p.id;});b.setAttribute('aria-pressed',String(active));b.textContent=active?'Remove from comparison':'Compare';}catch(e){}});}
  function value(p,key){return p[key]||'Not listed';}
  function gear(p){if(p.powerplant==='PCP')return 'Matching ammunition and a suitable high-pressure air source; check scope and rings included.';if(p.powerplant==='CO2')return 'Matching ammunition and the specified CO2 cartridges; check what is included.';if(p.type==='Scopes')return 'Rings matching the tube diameter and rifle rail; verify recoil suitability.';if(p.type==='Pcp Accessories')return 'Compatible fill fittings and pressure-rated equipment; check power requirements.';return 'Matching ammunition; check included accessories on the product page.';}
  function open(){if(!selected.length)return;lastFocus=document.activeElement;var table=document.createElement('table'), head=document.createElement('tr');head.appendChild(document.createElement('th'));selected.forEach(function(p){var th=document.createElement('th'),a=document.createElement('a');th.scope='col';a.href=p.url;a.textContent=p.title;th.appendChild(a);head.appendChild(th);});table.appendChild(head);
    var rows=[['Price',function(p){return p.price;}],['Option',function(p){return p.option==='Default Title'?'Single option':p.option;}],['Availability',function(p){return p.available?'In stock':'Sold out';}],['Caliber',function(p){return value(p,'caliber');}],['Powerplant',function(p){return value(p,'powerplant');}],['Action',function(p){return value(p,'action');}],['Regulated status',function(p){return value(p,'regulated');}],['Weight class',function(p){return value(p,'weight');}],['Magnification',function(p){return value(p,'magnification');}],['Scope tube',function(p){return value(p,'tube');}],['Focal plane',function(p){return value(p,'focal');}],['Parallax',function(p){return value(p,'parallax');}],['Air equipment type',function(p){return value(p,'equipment');}],['Required equipment',gear]];
    rows.forEach(function(row){if(row[0]!=='Required equipment'&&selected.every(function(p){return row[1](p)==='Not listed';}))return;var tr=document.createElement('tr'),th=document.createElement('th');th.scope='row';th.textContent=row[0];tr.appendChild(th);selected.forEach(function(p){var td=document.createElement('td');td.textContent=row[1](p);tr.appendChild(td);});table.appendChild(tr);});modal.querySelector('[data-comparison-table]').replaceChildren(table);modal.hidden=false;document.body.classList.add('compare-open');modal.querySelector('[data-close-comparison]').focus();}
  function close(){modal.hidden=true;document.body.classList.remove('compare-open');if(lastFocus&&lastFocus.isConnected)lastFocus.focus();}
  document.addEventListener('click',function(e){var pick=e.target.closest('[data-compare-product]');if(pick){try{var p=JSON.parse(pick.getAttribute('data-compare-product')),i=selected.findIndex(function(s){return s.id===p.id;});if(i>=0)selected.splice(i,1);else if(selected.length<3)selected.push(p);else {tray.querySelector('[data-compare-count]').textContent='Limit: 3 products. Remove one to add another.';return;}update();}catch(error){}return;}if(e.target.closest('[data-show-comparison]'))open();if(e.target.closest('[data-clear-comparison]')){selected=[];update();}if(e.target.closest('[data-close-comparison]')||e.target===modal)close();});
  document.addEventListener('keydown',function(e){if(modal.hidden)return;if(e.key==='Escape'){e.preventDefault();close();}if(e.key==='Tab'){var focus=Array.from(modal.querySelectorAll('button,a[href]')).filter(function(el){return !el.disabled;}),first=focus[0],last=focus[focus.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
  new MutationObserver(function(){update();}).observe(document.querySelector('[data-infinite-grid]')||document.querySelector('main')||document.body,{childList:true});
})();

/* Close mobile navigation with Escape or a click outside the menu. */
(function () {
  var summary = document.querySelector('summary[aria-label="Open navigation menu"]');
  var menu = summary && summary.closest('details');
  if (!menu) return;
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      summary.focus();
    }
  });
  document.addEventListener('click', function (event) {
    if (menu.open && !menu.contains(event.target)) menu.open = false;
  });
})();
